jQuery(function() {

    // Special Navigation wird gänzlich über TS eingefügt > siehe Setup.typoscript
    /*
    const $target = $('#mobileBottomTrigger');

    if ($target.length) {

        const urlFreizeit = $target.data('url-freizeit') || '#';
        const urlBusiness = $target.data('url-business') || '#';
        const urlGruppen = $target.data('url-gruppen') || '#';
        const titleBusiness = $target.data('title-business') || 'Business';
        const titleGruppen = $target.data('title-gruppen') || 'Gruppen';

        const $wrapper = $(`
            <div class="specialNav">
            <ul>
                <li><a href="${urlFreizeit}" role="button">Freizeit</a></li>
                <li><a href="${urlBusiness}" role="button">${titleBusiness}</a></li>
                <li><a href="${urlGruppen}" role="button">${titleGruppen}</a></li>
            </ul>
            </div>
        `);

        $target.after($wrapper);

        const $naviHolder = $('#newWAheader .naviHolder');
        const $specialNavMobile = $('.specialNav').clone();
        $specialNavMobile.insertAfter($naviHolder.find('#specialNavigation'));
    }
        */

});
